<template>
  <ul class="listing-filters-buttons">
    <li
      v-for="category in families"
      :key="category.id"
      data-animate="listing-filters-link"
    >
      <button
        class="listing-filters-buttons__button text flex --align-center --justify-space-between"
        @click="selectCategory(category.id)"
        :data-active="selectedCategories.includes(category.id)"
      >
        <span>{{ category.title }}</span>

        <span class="listing-filters-buttons__button__ico">
          <img
            src="~/assets/img/ico/ico-delete-light.svg"
            alt="Ico delete light"
            width="14"
            height="14"
          />
        </span>
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ListingFiltersButtons',
}
</script>

<script setup>
const emit = defineEmits(['selected'])

const props = defineProps({
  families: Array,
})

const router = useRouter()
const route = useRoute()

// Inizializza le variabili reattive che conterranno le famiglie e le categorie di prodotti
const selectedOnLoad = route.query?.categories
  ? [].concat(route.query?.categories)
  : []

const selectedCategories = ref(selectedOnLoad)

watch(
  () => selectedCategories.value,
  (selectedCategories) => {
    router.push({
      query: {
        categories: selectedCategories,
      },
    })
    emit('selected', selectedCategories)
  }
)

// Definisce una funzione per selezionare o deselezionare una categoria
const selectCategory = async (id) => {
  // Set per garantire che ogni categoria sia unica
  const set = new Set(selectedCategories.value)

  // Se la categoria è già selezionata, la rimuove, altrimenti la aggiunge
  if (set.has(id)) {
    set.delete(id)
  } else {
    set.add(id)
  }

  selectedCategories.value = Array.from(set)
}
</script>

<style lang="scss">
@import './style.scss';
</style>
